import { LayoutGrid, Monitor, Package, Mail, Camera } from 'lucide-react';

export default function DesktopNav({ darkMode, currentSection, scrollToSection, setDarkMode }) {
  const navItems = [
    { id: 'home', icon: <LayoutGrid size={18} />, label: 'Home' },
    { id: 'about', icon: <Monitor size={18} />, label: 'About' },
    { id: 'services', icon: <Package size={18} />, label: 'Services' },
    { id: 'events', icon: <Camera size={18} />, label: 'Events' },
    { id: 'contact', icon: <Mail size={18} />, label: 'Contact' },
  ];

  return (
    <div
      className="fixed left-0 top-0 h-full w-20 hidden lg:flex flex-col items-center py-8 z-30"
      style={{ background: 'var(--navy)', borderRight: '1px solid rgba(201,168,76,0.15)' }}
    >
      <div className="mb-12">
        <button
          onClick={() => scrollToSection('home')}
          className="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center"
          style={{ border: '2px solid var(--gold)' }}
        >
          <img src="images/favicon.png" alt="logo" className="w-full h-full object-cover" />
        </button>
      </div>

      <nav className="flex-1 flex flex-col items-center justify-center space-y-6">
        {navItems.map((item) => {
          const isActive = currentSection === item.id;
          return (
            <div key={item.id} className="flex flex-col items-center">
              <button
                onClick={() => scrollToSection(item.id)}
                title={item.label}
                className="w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-200"
                style={{
                  background: isActive ? 'rgba(201,168,76,0.15)' : 'transparent',
                  color: isActive ? 'var(--gold)' : 'var(--slate)',
                  border: isActive ? '1px solid rgba(201,168,76,0.4)' : '1px solid transparent',
                }}
              >
                {item.icon}
              </button>
              {isActive && (
                <div className="w-1 h-1 rounded-full mt-1" style={{ background: 'var(--gold)' }} />
              )}
            </div>
          );
        })}
      </nav>
      <div className="h-10" />
    </div>
  );
}